import './navigation.css';

import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { userConfigState } from '../../../recoil/atoms/userConfigState';
import { translate } from '../../../../common/language/translations';
import { getTenantColor } from '../../../static/tenantConfigs';


interface SimpleTabsProps {
  tabOptions: string[];
  activeTab: number,
  setActiveTab: (tab: number) => void;
}


export const SimpleTabs: React.FC<SimpleTabsProps> = ({
  tabOptions,
  activeTab,
  setActiveTab,
}) => {

  const tabWidth = 100 / tabOptions.length;
  const [tabLineContainerLeft, setTabLineContainerLeft] = useState('0%');


  const updateTabLine = (tab: number) => {
    const lineContainer = document.getElementById('simple-tab-line-container');
    if (lineContainer) {
      setTabLineContainerLeft(`${tab * tabWidth}%`);
    }
  };


  const handleSetActiveTab = (tab: number) => {
    setActiveTab(tab);
    updateTabLine(tab);
  };


  const userConfig = useRecoilValue(userConfigState);

  return (
    <div className='simple-tabs-section'>

      <div
        id='simple-tab-line-container'
        className='simple-tab-line-container'
        style={{
          width: `${tabWidth}%`,
          left: tabLineContainerLeft,
        }}
      >
        <div
          className='simple-tab-line'
          style={{
            backgroundColor: getTenantColor(userConfig?.club ?? ''),
          }}
        />
      </div>

      {tabOptions.map((tabOption, index) => {

        return (
          <div
            key={index}
            className={'simple-tabs-tab' + (activeTab === index ? ' simple-tabs-tab-active' : '')}
            style={{ width: `${tabWidth}%` }}
            onClick={() => handleSetActiveTab(index)}
          >
            {translate(tabOption, userConfig?.language)}
          </div>
        );
      })}

    </div>
  );
};
